/* @sravni/react-design-system version 0.2.65 */
var css = "._16xbygj {\n  overflow: hidden;\n}\n._1rmt4yu {\n  display: block;\n}\n._19bu7fo {\n  display: none;\n}\n";
var modules_a1e6048f = {"collapseOverflow":"_16xbygj","collapseVisible":"_1rmt4yu","collapseHidden":"_19bu7fo"};
import "../../../assets/components/Transition/src/Collapse-a658d8d1.css";

export default modules_a1e6048f;
export { css };
